import { Skeleton } from '@/components/ui/skeleton';
import { getEntityQueryOptions } from '@/queries/getEntityQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'
import type { IMergableDocument } from '../data-sources';
import type { DataSourceParameter } from '@/models/data-source-parameter';
import { ParametersManager } from '@/components/filter-builder/parameters-manager-direct';
import { updateEntity } from '@/queries/updateEntityMutation';

export const Route = createFileRoute(
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/parameters/',
)({
    component: RouteComponent,
})

function RouteComponent() {
    const { entity_type_id, entity_id } = Route.useParams();
    const { data: result, isLoading, refetch } = useQuery(getEntityQueryOptions(entity_type_id, entity_id));

    if (isLoading) {
        return <>
            <Skeleton className="h-10 w-1/3 mb-4" />
            <Skeleton className="h-10 w-full mb-4" />
            <Skeleton className="h-10 w-full mb-4" />
            <Skeleton className="h-10 w-full mb-4" />
        </>
    }
    return <EntityParameters
        entity={result?.entity as IMergableDocument}
        entity_type_id={entity_type_id}
        onUpdate={refetch}
    />;
}

function EntityParameters({
    entity,
    entity_type_id,
    onUpdate
}: {
    entity: IMergableDocument,
    entity_type_id: string,
    onUpdate: () => void
}) {
    const updateMutation = updateEntity();

    const handleParametersSave = async (newParameters: DataSourceParameter[]) => {
        if (!entity.id) return;

        try {
            await updateMutation.mutateAsync({
                entityType: entity_type_id,
                entityId: entity.id,
                updates: {
                    parameters: newParameters
                }
            });
            await onUpdate();
        } catch (error) {
            console.error('Failed to save parameters:', error);
        }
    };

    return (
        <ParametersManager
            parameters={entity.parameters || []}
            onSave={handleParametersSave}
            entity_type_id={entity_type_id}
        />
    );
}
